<template>
  <div class="publicMain">
    <div class="mianbao">
      <!--  -->
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item >社区治理</el-breadcrumb-item>
        <el-breadcrumb-item>救助管理</el-breadcrumb-item>
        <el-breadcrumb-item>救助公示</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <el-tabs v-model="activeName" type="card">
      <el-tab-pane label="基本信息" name="first">
        <transition
          name="fade"
          appear
          enter-active-class="animated bounceInRight"
          leave-active-class="animated bounceInRight"
          :duration="{enter:1200,leave:1400}"
        >
          <oldManFileFirst v-if="activeName=='first'" :query='$route.query' @save='save'/>
        </transition>
      </el-tab-pane>
      <el-tab-pane label="健康指数" name="second">
        <transition
          name="fade"
          appear
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceInLeft"
          :duration="{enter:1200,leave:1400}"
        >
          <oldManFileSecond v-if="activeName=='second'" :query='$route.query' @save='save'/>
        </transition>
      </el-tab-pane>
      <el-tab-pane label="用药记录" name="third">
        <transition
          name="fade"
          appear
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceInLeft"
          :duration="{enter:1200,leave:1400}"
        >
          <oldManFileThird v-if="activeName=='third'" />
        </transition>
      </el-tab-pane>
      <el-tab-pane label="就诊记录" name="fourth">
        <transition
          name="fade"
          appear
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceInLeft"
          :duration="{enter:1200,leave:1400}"
        >
          <oldManFileFourth v-if="activeName=='fourth'" />
        </transition>
      </el-tab-pane>
      <el-tab-pane label="体检记录" name="fifth">
        <transition
          name="fade"
          appear
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceInLeft"
          :duration="{enter:1200,leave:1400}"
        >
          <oldManFileFifth v-if="activeName=='fifth'" />
        </transition>
      </el-tab-pane>
      <el-tab-pane label="帮扶记录" name="sixth">
        <transition
          name="fade"
          appear
          enter-active-class="animated bounceInLeft"
          leave-active-class="animated bounceInLeft"
          :duration="{enter:1200,leave:1400}"
        >
          <oldManFileSixth v-if="activeName=='sixth'" />
        </transition>
      </el-tab-pane>
<!--      <el-tab-pane label="评估报告" name="seventh">-->
<!--        <transition-->
<!--          name="fade"-->
<!--          appear-->
<!--          enter-active-class="animated bounceInLeft"-->
<!--          leave-active-class="animated bounceInLeft"-->
<!--          :duration="{enter:1200,leave:1400}"-->
<!--        >-->
<!--          <oldManFileSeventh v-if="activeName=='seventh'" />-->
<!--        </transition>-->
<!--      </el-tab-pane>-->
    </el-tabs>
  </div>
</template>

<script>
import {
  getAllChildrenActiveList,
  childrenActiveHomeEdit,
  childrenActiveHomeDelete,
  childrenActiveHomePass
} from "./api";
import oldManFileFirst from "./components/oldManFileFirst.vue";
import oldManFileSecond from "./components/oldManFileSecond.vue";
import oldManFileThird from "./components/oldManFileThird.vue";
import oldManFileFourth from "./components/oldManFileFourth.vue";
import oldManFileFifth from "./components/oldManFileFifth.vue";
import oldManFileSixth from "./components/oldManFileSixth.vue";
import oldManFileSeventh from "./components/oldManFileSeventh.vue";
export default {
  components: {
    oldManFileFirst,
    oldManFileSecond,
    oldManFileThird,
    oldManFileFourth,
    oldManFileFifth,
    oldManFileSixth,
    oldManFileSeventh
  },
  data() {
    return {
      currentPage: 1, //默认展示第一页
      buttonType: "", //按钮的类型
      row: {}, //点击当前按钮的row数据
      title: "",
      visible: false,
      activeName: "first", //el-tabs切换的
      formModel: {}, //模糊查询
      //table表格的column
      tableColumn: [
        {
          prop: "theme",
          label: "活动主题"
        },
        {
          prop: "startTime",
          label: "活动开始时间"
        },
        {
          prop: "entTime",
          label: "活动结束时间"
        },
        {
          prop: "homeAddress",
          label: "活动地点"
        },
        {
          prop: "contacts",
          label: "联系人"
        },
        {
          prop: "contactNumber",
          label: "联系电话"
        },
        {
          type: "mode",
          prop: "mode",
          label: "参与方式"
        },
        {
          type: "state",
          prop: "state",
          label: "状态"
        },
        {
          type: "button"
        }
      ],
      //table表格的数据
      tableData: [],
      total: 0, //总数据
      pageNo: 1,
      pageSize: 10
    };
  },
  methods: {
    save(e){
      this.activeName = e
    }
  },
  created() {

  }
};
</script>

<style lang="less" scoped>
.publicMain {
  background-color: #fff;
  padding: 16px;
  box-sizing: border-box;
  width: 100%;
  height: 100%;

}
// 面包屑导航box
.mianbao {
  box-sizing: border-box;
  margin: -16px -16px 0;
  background-color: #eef1f6;
  height: 47px;
  align-items: center;
  padding-left: 16px;
  margin-bottom: 16px;
}
.childrenFileSelect {
  margin-top: 20px;
}
.table {
  margin: 20px 0px;
}
.add {
  margin: 20px 0px;
}
.slot {
  width: 90%;
  margin: auto;
}
</style>
